<style scoped>
    .el-card{
        min-height: 146px;
        margin-top: 5px;
    }
    .second-card {
        min-height: 102px;
        margin-top: 5px;
        text-align: center;
        color: rgba(0, 0, 0, 0.427450980392157);
    }
    .second-card-subtext{
        font-size: 26px;
        margin-top: 10px;
        text-align: center;
        color: rgba(0, 0, 0, 0.847058823529412);
    }

    .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{
        box-shadow:none;
    }
    .primary-card-title{
        font-size: 14px;
        color: rgba(0, 0, 0, 0.427450980392157);
    }
    .primary-card-text{
        font-size: 30px;
    }
    .card {
        border: 1px solid #eee;
        padding: 20px;
        text-align: center;
    }
</style>
<template>
<div>

    <el-row>
        <el-col :span="15">
            <p style="font-size: 20px;">{{pm}}，{{name}}，祝开心每一天！</p>
            <p style="font-size: 14px;color: rgba(0, 0, 0, 0.427450980392157);margin-top: 25px;">今天，{{date}} {{week}}，欢迎您回到工作台。</p>
        </el-col>

        <el-col :span="2" style="float:right;text-align: center;cursor: pointer">
            <p style="font-size: 14px;color:rgba(0, 0, 0, 0.427450980392157);">入驻申请</p>
            <p style="font-size: 30px;color: #1890FF;" @click="$router.push('/home/plusBusinessTabIndex/second')">{{homeData.businessAuthCount|defaultFilter}}</p>
        </el-col>
        <el-col :span="2" style="float:right;text-align: center;cursor: pointer" >
            <p style="font-size: 14px;color:rgba(0, 0, 0, 0.427450980392157);">二手车待审核</p>
            <p style="font-size: 30px;color: #1890FF;" @click="$router.push({name:'二手车管理',query:{status:3}})">{{homeData.privateUsedCarAuthCount|defaultFilter}}</p>
        </el-col>

    </el-row>
    <hr/>

    <el-row :gutter="20">
        <el-col :span="6" >
            <div class="card">
                <div class="primary-card-title">累计线上收入(元)</div>
                <div class="primary-card-text">{{homeData.channelTotal}} </div>
                <hr/>
                <div style="text-align: center">
                    <span  style="color:rgba(0, 0, 0, 0.427450980392157);">近30天收入 <span style="color: rgba(0, 0, 0, 0.647058823529412);">{{homeData.thirtyDayChannelTotal}}</span></span>
                    <span style="margin-left:20px;color:rgba(0, 0, 0, 0.427450980392157);">今日收入 <span style="color: rgba(0, 0, 0, 0.647058823529412);">{{homeData.todayChannelTotal}}</span></span>
                </div>
            </div>
        </el-col>
        <el-col :span="6">
            <div class="card">
                <div class="primary-card-title">当前展示二手车源(条)</div>
                <div class="primary-card-text">{{homeData.privateUsedCarShowCount}} </div>
                <hr/>
                <div style="text-align: center">
                    <span style="color:rgba(0, 0, 0, 0.427450980392157);">累计发布 <span style="color: rgba(0, 0, 0, 0.647058823529412);">{{homeData.privateUsedCarTotalCount}}</span></span>
                    <span style="margin-left:20px;color:rgba(0, 0, 0, 0.427450980392157);">昨日发布 <span style="color: rgba(0, 0, 0, 0.647058823529412);">{{homeData.privateUsedCarYesterdayCount}}</span></span>
                </div>
            </div>
        </el-col>
        <el-col :span="6">
            <div class="card">
                <div class="primary-card-title">当前已入驻商家</div>
                <div class="primary-card-text">{{homeData.successBusinessCount}} </div>
                <hr/>
                <div style="text-align: center;color:rgba(0, 0, 0, 0.427450980392157);" >累计收集线索 <span style="color: rgba(0, 0, 0, 0.647058823529412);">{{homeData.clueTotalCount}}</span></div>
            </div>
        </el-col>
        <el-col :span="6">
            <div class="card">
                <div class="primary-card-title">昨日PV/UV</div>
                <div class="primary-card-text">{{homeData.yesterdayPv}} /{{homeData.yesterdayUv}} </div>
                <hr/>
                <div style="text-align: center">
                    <span style="color:rgba(0, 0, 0, 0.427450980392157);">累计注册用户 <span style="color: rgba(0, 0, 0, 0.647058823529412);">{{homeData.lcwUserInfoCount}}</span></span>

                </div>
            </div>
        </el-col>

    </el-row>

</div>
</template>
<script>
import echarts from 'echarts'
import usedCarModel from '@/framework/models/usedCarModel'

import BasicPager from '@/mixins/BasicPager'
export default {
  extends: BasicPager,
  name: 'private-car-home',
  data () {
    return {
      date: null,
      pm: null,
      week: null,
      name: null,
      homeData: {}
    }
  },
  mounted () {
    this.name = this.loginInfo.realName
    this.week = this.getWeek()
    this.date = this.getDate()
    this.pm = this.getPm()
    this.loadDataInfo()
  },
  methods: {

    getPm () {
      let str = ''
      let now = new Date()
      let hour = now.getHours()
      if (hour < 6) {
        str = '凌晨好'
      } else if (hour < 9) {
        str = '早上好'
      } else if (hour < 12) {
        str = '上午好'
      } else if (hour < 14) {
        str = '中午好'
      } else if (hour < 17) {
        str = '下午好'
      } else if (hour < 19) {
        str = '傍晚好'
      } else if (hour < 22) {
        str = '晚上好'
      } else {
        str = '夜里好'
      }
      return str
    },
    getDate () {
      let unixtime = new Date().getTime()

      let localeDate = new Date(unixtime)
      let year = localeDate.getFullYear()
      let month = localeDate.getMonth() + 1
      let day = localeDate.getDate()
      let dateText = year + '年' + (month < 10 ? '0' + month : month) + '月' + (day < 10 ? '0' + day : day) + '日'
      return dateText
    },
    getWeek () {
      var str = ''
      var week = new Date().getDay()
      if (week == 0) {
        str = '星期日'
      } else if (week == 1) {
        str = '星期一'
      } else if (week == 2) {
        str = '星期二'
      } else if (week == 3) {
        str = '星期三'
      } else if (week == 4) {
        str = '星期四'
      } else if (week == 5) {
        str = '星期五'
      } else if (week == 6) {
        str = '星期六'
      }
      return str
    },
    loadDataInfo () {
      let _this = this

      let id = null
      if (this.loginInfo.loginPath == 'channel') {
        id = this.loginInfo.id
      }

      let params = {
        id: id
      }

      let listener = {
        success (dataInfo) {
          let datas = dataInfo.datas

          _this.homeData = datas

          _this.myEcharts(datas)
        }
      }

      usedCarModel.getPriveteUsedCarIndex(_this, params, listener)
    }

  }
}
</script>
